export const getWebsiteURL = (path) => {
  return "https://educationplanner.io"+path.toLowerCase();
};